/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Heading2({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M1.6 2.5a.6.6 0 1 0-1.2 0v11a.6.6 0 1 0 1.2 0V8.457h6.3V13.5a.6.6 0 1 0 1.2 0v-11a.6.6 0 1 0-1.2 0v4.757H1.6V2.5ZM12.75 6.4a2.35 2.35 0 0 0-2.35 2.35V9a.6.6 0 0 0 1.2 0v-.25a1.15 1.15 0 0 1 2.3 0v.422a1.4 1.4 0 0 1-.41.99l-2.914 2.914A.6.6 0 0 0 11 14.1h3.5a.6.6 0 1 0 0-1.2h-2.051l1.89-1.89a2.6 2.6 0 0 0 .761-1.838V8.75a2.35 2.35 0 0 0-2.35-2.35Z" /></svg>;
}
;